<template>
	<div class=" investmentClues">
		<leftnav class="fl" mkcode="T" itemcode="T-BGQYND"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">{{ curWebsite.type == 5 ? '投资' : "产业" }}动态</span>
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<!-- 投资版名字 上市公司投资 -->
							<dynamicNavTZ code="ssgstz"></dynamicNavTZ>
							<!-- 投资时间 -->
							<finacingTime v-on:chooseFinancing="chooseFinancing" :isChoose="false" dlname="投资" type="day"></finacingTime>
							<dl class="opport-screen bdbe">
								<dt class="fl">投资模式</dt>
								<dd class="fl">
									<!-- <span :class="node == ''?'a-screen current':'a-screen'" 	@click="node='';getclue()">全部</span> -->
									<span :class="node == list.paraValue ? 'a-screen current' : 'a-screen'"
										v-for="(list, i) in investPattern" :key="i"
										@click="isShowFreeUserTips = true">{{ list.paraName }}</span>
								</dd>
							</dl>

							<dl class="opport-screen bdbe">
								<dt class="fl">投资地点</dt>
								<dd class="fl">
									<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
										@click="provincechoose(0, 'all');  ">全国地区</span>
									<span v-for="(item, index) in provincedata" :key="index"
										@click="provincechoose(item.areaId, index);  "
										:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
								</dd>
							</dl>

							<dl class="opport-screen bdbe" v-show="citydata.length != 0">
								<dt class="fl">城市地区</dt>
								<dd class="fl">
									<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
										@click="choosecity(0, 'all'); ">全部</span>
									<span v-for="(item, index) in citydata" :key="index"
										@click="choosecity(item.areaId, index); cityid = item.areaId;"
										:data="item.areaId"
										:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
								</dd>
							</dl>
							<!-- 热点行业 -->
							<projectIndustry type="invest" :isChoose="false" @getIndustryId="getIndustryId" :token="userdata.token">
							</projectIndustry>
							<!-- 		<dl class="opport-screen bdbe">
								<dt class="fl">热点产业</dt>
								<dd class="fl">
									<span v-for="(item,index) in hotindustry" @click="industrychoose(1,item);"  :key="index" 
										:class="industrycode1 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="hotindustrychild.length>0">
								<dt class="fl titleop">细分产业</dt>
								<dd class="fl">
									<span @click="industrycode2='';getclue()"
										:class="industrycode2 == ''?'a-screen current':'a-screen'">全部</span>
									<span v-for="(item,index) in hotindustrychild" @click="industrychoose(2,item);"  :key="index" 
										:class="industrycode2 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
								</dd>
							</dl> -->
						</div>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 表格内容开始 -->
				<div class="whitebox" style="margin-top: 10px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条匹配的投资动态</p>
					</div>
					<!-- 资本招商线索 -->
					<div class="enterprise_list_box">
						<!-- 标杆企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpristlist.length > 0">
							<tr>
								<th>排名</th>
								<th>公司名称</th>
								<th>项目名称</th>
								<th>投资来源地</th>
								<th>行业</th>
								<!-- <th>概念</th> -->
								<th>投资地点</th>
								<th>投资金额 </th>
								<th>日期 </th>
							</tr>
							<tr v-for="(list, i) in enterpristlist" v-if="enterpristlist.length > 0" :key="i">
								<td>{{ 20 * (page - 1) + i + 1 }}</td>
								<td class="title" @click="detailrouterto('/enterprises', list.stockCode, list.shortName)">
									{{ list.shortName }}
								</td>
								<td>{{ list.projectName }}</td>
								<td>{{ list.sourceArea == '' ? '-' : list.sourceArea }}</td>
								<td>{{ list.industry }}</td>
								<!-- <td>{{list.notion==''?'-':list.notion}}</td> -->
								<td>{{ list.investArea }}</td>
								<td>{{ list.money }}{{ list.moneyUnit }}</td>
								<td>{{ list.time }}</td>
							</tr>
						</table>


					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { dataInJs } from "@/utils/city.js";
import { getMonthLength } from '@/utils/common.js'
import projectIndustry from "@/components/inc/project-industry-list.vue"
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'markenterprise',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: '上市公司投资动态',
			curWebsite: this.$api.getWebsiteType(),
			notioneditbtn: true, //是否修改notion  
			cityflag: false, //显示城市地图
			usernotionid: 10, //用户选择id 
			notionlist: [], //用户初始概念数据 
			notioncodelist: [], //用户初始概念数据id  
			usernotionlistsave: [], //用户选择的概念列表存储
			usernotionlist: [], //用户选择的概念列表
			total1: 0,
			userdata: {},
			searchtype: 3, //标杆企业投资
			pro: 11,
			node: 0,
			liancity: 0, //产业链线索城市
			city4: 1,
			frequency: 1, //融资频次 
			provincedata:dataInJs(),
			countydata: [],
			citydata: [],
			provinceid: 0,
			cityid: 0,
			countyid: 0,
			industryoptions1: [],
			lianctiy: [],
			cstype: 1, //1供应商 2客户
			supplierlist: [], //供应商列表
			customerlist: [], //客户列表
			ipolist: [], //上市公司列表
			enterpristlist: [],
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数 
			totalPage: 1,
			maxPage: 10, //最大页数 
			areadata: dataInJs(), //省份城市数据 
			financingTime: [],
			finantime: '2023-03-01',//每个月都要修改  updatetime
			finantime2: "2024-02-29",
			investPattern: [{
				id: 0,
				name: '全部'
			}, {
				id: 1,
				name: '独立投资'
			}, {
				id: 2,
				name: '合资经营'
			}, {
				id: 3,
				name: '股权投资'
			}, {
				id: 4,
				name: '并购'
			}, {
				id: 5,
				name: '增资'
			}],
			hotindustry: [],
			hotindustrychild: [],
			industrycode1: "",
			industrycode2: 0,
			industryid: 0,
			ordertype: 0, //0降序 1升序
			orderfield: 1, //0降序 1升序
			isShowFreeUserTips:false,
		}
	},
	components: {
		projectIndustry
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this; 
		_this.provincedata = this.areadata;
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		// this.pro = this.userdata.province;
		this.getinvestPattern();
		// this.getinvestArea();
		// this.gethotindustry();
		this.getclue();
		this.finantime = '2023-03-01';//每个月都要修改  updatetime
		this.finantime2 = "2024-02-29";
	},
	methods: {
		//接收子元素传过来的时间
		chooseFinancing(date1, date2) {
			var date2 = date1 + '-' + getMonthLength(date1);
			this.finantime = date1 == 'year' ? '2023-03-01' : date1 + '-01';
			this.finantime2 = date1 == 'year' ? '2024-02-29' : date2;
			this.getclue();
		},
		//时间/分数升降序
		tablesort(field) {
			console.log(field, this.orderfield);
			if (field == this.orderfield) {
				this.ordertype = Math.abs(this.ordertype - 1);
			} else {
				this.orderfield = field;
			}
			// this.getclue();
		},

		choosecityide(art) {
			// console.log(art);
			this.choosecityid(art[0], art[1]);
		},
		//省份城市选择
		provincechoose(id, i) {
			this.isShowFreeUserTips = true;
			return;
			this.provinceid = id;
			this.cityid = 0;
			this.countyid = 0;
			this.countydata = [];
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.page = 1;
			// this.ajaxsearchcompany();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id;
			this.countyid = 0;
			if (i != "all" && this.citydata[i].children != null) {
				this.countydata = this.citydata[i].children;
			} else {
				this.countydata = [];
			}
			this.page = 1;
			// this.ajaxsearchcompany(); 
		},
		choosecounty(id) {
			//	console.log('choosecity',id);
			this.countyid = id;
			this.page = 1;
			// this.ajaxsearchcompany();
		},
		//点击热点行业后
		getIndustryId(id, code1, code2) {
			this.industryid = id;
			this.industrycode1 = code1;
			this.industrycode2 = code2;
			this.getclue();
		},
		 
		//获取投资模式
		getinvestPattern() {
			var _this = this,
				ajaxurl = '';
			ajaxurl = this.$api.free.invest.parameterList() + '?categoryId=4';
			this.$axios.get(ajaxurl).then(function (res) {
				console.log("投资模式", res, ajaxurl);
				if (res.data.success) {
					_this.investPattern = res.data.list;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取投资地点
		getinvestArea() {
			var _this = this,
				ajaxurl = '';
			ajaxurl = this.$api.investapi.area.province();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("区域", res, ajaxurl);
				if (res.data.success) {
					_this.provincedata = res.data.list;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取产业链/区域/融资企业招商线索
		getclue(pages) {
			var _this = this,
				ajaxurl = '';
			_this.bus.$emit('loading', true);
			var ajpage = 1;
			if (pages) {
				ajpage = pages;
			}
			this.page = ajpage;
			var investMode = this.splicing('investMode', this.node);
			var industryja1 = this.splicing('industry1', this.industrycode1);
			var industryja2 = this.splicing('industry2', this.industrycode2);
			// var date2 = '';
			// for (var i = 0; i < this.financingTime.length - 1; i++) {
			// 	if (this.finantime != '' && i < this.financingTime.length) {
			// 		if (this.financingTime[i].time == this.finantime) {
			// 			date2 = this.financingTime[i + 1].time;
			// 		}
			// 	}
			// } 
			var date1 = this.splicing('date1', this.finantime);
			var date2json = this.splicing('date2', this.finantime2);
			ajaxurl = this.$api.free.invest.list() ;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log(_this.usernotionlist,_this.notionlist);
				console.log("列表", res, ajaxurl);
				if (res.data.success) {
					_this.enterpristlist = res.data.list;
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			if(page>1){
				this.isShowFreeUserTips = true;
				return;

			}
			this.page = page;
			this.getclue(page);
		},
		detailrouterto(path, id, title) {
			// console.log(title);
			if (id == 0 || id == "") {
				return;
			}
			let routeUrl = this.$router.resolve({
				path: path,
				query: {
					id: id,
					ctitle: title
				},
			});
			window.open(routeUrl.href, '_blank');
		},
		jsondouhao(name, data) {
			if (data.length > 0) {
				var notionja = "";
				if (data.length != 0) {
					var douhao = '%2C';
					for (var i = 0; i < data.length; i++) {
						if (i == data.length - 1) {
							douhao = '';
						}
						notionja += data[i].id + douhao;
					}
					notionja = '&' + name + '=' + notionja;
					return notionja;
				}
			} else {
				return "";
			}
		},
	},
}
</script>

<style>
/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	border-top-color: #E0E8F9;
}

.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	border-top-color: #E0E8F9;
}

/* 提示框背景色 */
.atooltip {
	background: #E0E8F9 !important;
}</style>